import css from 'styled-jsx/css';

const style = css`
  .wrapper {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .edit-button {
    cursor: pointer;
  }
  .disabled-edit-button {
    cursor: not-allowed;
  }
  .warning-icon {
    width: 16px;
    height: 16px;
    margin-right: 4px;
    margin-bottom: 2px;
  }
  .add-button {
    width: 18px;
    height: 18px;
    cursor: pointer;
  }
`;

export default style;
